import { Tag, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { IntegrationStatus } from '@features/bills/types/integrationStatus'
import { useBillIntegrationStatusTooltipMessageKey } from '@views/bills/hooks/useBillIntegrationStatusKey'
import { getLatestIntegrationStatus } from '@views/bills/utils/getLatestIntegrationStatus'

import { getReceiptTransferStatusBadgeConfig } from '../../utils/getReceiptTransferStatusBadgeConfig'
import * as Styled from './styles'

interface ReceiptTransferStatusBadgeProps {
  integrationStatuses?: IntegrationStatus[]
}

export const ReceiptTransferStatusBadge = ({ integrationStatuses }: ReceiptTransferStatusBadgeProps): ReactElement => {
  const { t } = useTranslation()
  const statusBadgeConfig = getReceiptTransferStatusBadgeConfig(integrationStatuses)
  const integrationStatus = getLatestIntegrationStatus(integrationStatuses)
  const tooltipKey = useBillIntegrationStatusTooltipMessageKey(integrationStatus)

  if (!statusBadgeConfig || !tooltipKey) {
    return <></>
  }

  const { color, icon, labelKey } = statusBadgeConfig

  return (
    <Styled.BadgeWrapper>
      <Tooltip label={t(tooltipKey)} placement="top">
        <Tag color={color} icon={icon} size="sm" type="subtle">
          {t(labelKey)}
        </Tag>
      </Tooltip>
    </Styled.BadgeWrapper>
  )
}
